<script>
import { authComputed } from '@state/helpers'
// import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  // components: { VuePerfectScrollbar },
  props: {
    user: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    title: {
      type: String,
      required: false,
      default: () => '',
    },
  },
  data() {
    return {}
  },
  computed: {
    ...authComputed,
  },
  methods: {
    toggleMenu() {
      this.$parent.toggleMenu()
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar()
    },
  },
}
</script>

<template>
  <!-- Topbar Start -->
  <div class="navbar-custom">
    <ul class="list-unstyled topnav-menu float-right mb-0">
      <!-- <b-nav-item-dropdown right class="notification-list">
        <template
          slot="button-content"
          class="nav-link dropdown-toggle waves-effect waves-light"
        >
          <i class="fe-bell noti-icon"></i>
          <span class="badge badge-danger rounded-circle noti-icon-badge"
            >0</span
          >
        </template>

         <b-dropdown-text href="#" class="dropdown-item noti-title">
          <h5 class="m-0 text-center">
            Notification
          </h5>
        </b-dropdown-text>

        <b-dropdown-text href="#" class="p-0">
          <VuePerfectScrollbar v-once class="noti-scroll"></VuePerfectScrollbar>

          <a
            href="javascript:void(0);"
            class="dropdown-item text-center text-primary notify-item notify-all"
          >
            No New Updates!
            <i class="fi-arrow-right"></i>
          </a>
        </b-dropdown-text>
      </b-nav-item-dropdown> -->

      <b-nav-item-dropdown
        right
        class="notification-list"
        menu-class="profile-dropdown"
      >
        <template slot="button-content">
          <div class="nav-user mr-0 waves-effect waves-light">
            <img
              src="https://www.gravatar.com/avatar"
              alt="user-image"
              class="rounded-circle"
            />
            <span class="pro-user-name ml-1">
              {{ profileData ? profileData.first_name : '' }}
              ({{ profileData ? profileData.role : '' }})
              <i class="mdi mdi-chevron-down"></i>
            </span>
          </div>
        </template>

        <b-dropdown-item tag="a" to="/my-profile">
          <i class="fe-user mr-1"></i>
          <span>My Profile</span>
        </b-dropdown-item>
        <b-dropdown-item tag="a" to="/change-password">
          <i class="fe-lock mr-1"></i>
          <span>Change Password</span>
        </b-dropdown-item>
        <!-- <b-dropdown-item
          tag="a"
          href="https://qa-etp.mindzcloud.com"
          target="_blank"
        >
          <i class="fe-home mr-1"></i>
          <span>Go to ETP</span>
        </b-dropdown-item> -->

        <b-dropdown-divider></b-dropdown-divider>

        <b-dropdown-item href="/logout">
          <i class="fe-log-out mr-1"></i>

          <span>Logout</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </ul>

    <!-- LOGO -->
    <div class="logo-box">
      <a href="/" class="logo text-center">
        <span class="logo-lg">
          <img src="@assets/images/logo.png" alt="mindZcloud" height="60" />
        </span>
        <span class="logo-sm">
          <img src="@assets/images/logo.png" alt="mindZcloud" height="40" />
        </span>
      </a>
    </div>

    <ul class="list-unstyled topnav-menu topnav-menu-left m-0">
      <li>
        <button
          class="button-menu-mobile disable-btn waves-effect"
          @click="toggleMenu"
        >
          <i class="fe-menu"></i>
        </button>
      </li>

      <li>
        <h4 class="page-title-main"
          >{{ title || '' }}
          <a
            v-if="title === 'Start Meeting'"
            href="/meeting-list"
            style="margin-left:20px"
            class="btn btn-primary"
          >
            Back
          </a></h4
        >
      </li>
    </ul>
  </div>
  <!-- end Topbar -->
</template>
